<div class="modal-header" id="confirmation-add-attendee-modal-title">
    <h3 class="modal-title" id="modal-title">{{ titleText }}</h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="attendeeForm">
        <fieldset formArrayName="formChildren">
            <div class="row mb-3">
                <label class="col-2 col-form-label" translate="CONFIRMATION_ATTENDEELIST_TITLE_LABEL"></label>
                <div class="col-5">
                    <pace-core-dropdown
                        [(model)]="model.title"
                        (valueChange)="onTitleDropDownChange(model)"
                        [parentForm]="attendeeFormChildren"
                    ></pace-core-dropdown>
                </div>
                <div class="col-5">
                    <pace-core-checkbox-input
                        [(model)]="model.notReceivingCredit"
                        (valueChange)="setEmailAddressMandatory(model)"
                        [parentForm]="attendeeFormChildren"
                    ></pace-core-checkbox-input>
                </div>
            </div>
            <div *ngIf="displayTitleTextBox" class="row mb-3">
                <label class="col-2 col-form-label" translate="CONFIRMATION_ATTENDEELIST_TITLE_TEXT_LABEL"></label>
                <div class="col-9">
                    <pace-core-text-input
                        [(model)]="model.textTitle"
                        [parentForm]="attendeeFormChildren"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-2 col-form-label" translate="CONFIRMATION_ATTENDEELIST_FIRSTNAME_LABEL"></label>
                <div class="col-9">
                    <pace-core-text-input
                        [(model)]="model.firstName"
                        [parentForm]="attendeeFormChildren"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-2 col-form-label" translate="CONFIRMATION_ATTENDEELIST_LASTNAME_LABEL"></label>
                <div class="col-9">
                    <pace-core-text-input
                        [(model)]="model.lastName"
                        [parentForm]="attendeeFormChildren"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-2 col-form-label" translate="CONFIRMATION_ATTENDEELIST_EMAIL_LABEL"></label>
                <div class="col-9">
                    <pace-core-text-input
                        [(model)]="model.mail"
                        [parentForm]="attendeeFormChildren"
                    ></pace-core-text-input>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" [disabled]="attendeeForm.invalid" (click)="save()">{{ buttonText }}</button>
</div>
